(function () {
	$(window).on('load', function () {
		var VTBSlider = new Swiper('.price_wrap .swiper', {
			speed: 800,
			slidesPerView: 'auto',
			spaceBetween: 16,
			navigation:{nextEl:".price_wrap .swiper-arrow.next",prevEl:".price_wrap .swiper-arrow.prev"},
			breakpoints: {
				640: {
					spaceBetween: 20,
					slidesPerView: 1.6
				},
				1024: {
					spaceBetween: 30,
					slidesPerView: 2.2
				},
				1200: {
					spaceBetween: 30,
					slidesPerView: 3
				}
			}
		});

		// scroll
		const scaleSec = document.querySelector('.scale-section');
		let isInScaleSec = false;

		const scrollCount = () => {
			const rect = scaleSec.getBoundingClientRect();

			const options = {
				enableScrollSpy: true
			};

			// 判斷元素是否進入視窗範圍（上邊界 <= 視窗高度 && 下邊界 >= 0）
			if (rect.top <= window.innerHeight && rect.bottom >= 0) {
				if (isInScaleSec) return;
				isInScaleSec = true;

				const countEls = [...document.querySelectorAll('[data-count-end]')];

				countEls.forEach((item, idx) => {
					item.setAttribute('id', `count-${idx}`);
					const count = new CountUp(`count-${idx}`, 0, +item.dataset.countEnd, 0, 3, options);
					// console.log(count);
					if (!count.error) {
						count.start();
					}
				});
			} else {
				isInScaleSec = false;
			}
		}

		scrollCount()

		window.addEventListener('scroll', () => {
			scrollCount()
		});
	});
})(window, document);
